import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = "Cognisafe - AI Destekli İnsan Odaklı Siber Güvenlik Platformu",
  description = "Cognisafe, yapay zeka destekli davranış analizi ile siber güvenlik risklerini %95 doğrulukla tespit eden yenilikçi platform. Proaktif tehdit önleme ve uyarlanabilir öğrenme motoru.",
  keywords = "siber güvenlik, AI güvenlik, davranış analizi, tehdit tespiti, güvenlik eğitimi, yapay zeka, siber güvenlik platformu, risk analizi, güvenlik çözümleri, cognisafe",
  image = "https://cognisafe.com.tr/og-image.svg",
  url = "https://cognisafe.com.tr/",
  type = "website",
  structuredData = null
}) => {
  const defaultStructuredData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Cognisafe",
    "url": "https://cognisafe.com.tr",
    "logo": "https://cognisafe.com.tr/logo.png",
    "description": "AI destekli insan odaklı siber güvenlik platformu",
    "foundingDate": "2025",
    "industry": "Siber Güvenlik",
    "serviceType": "Siber Güvenlik Çözümleri",
    "areaServed": "Türkiye",
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "customer service",
      "availableLanguage": "Turkish"
    }
  };

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="robots" content="index, follow" />
      <meta name="language" content="Turkish" />
      <meta name="author" content="Cognisafe" />
      <link rel="canonical" href={url} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:site_name" content="Cognisafe" />
      <meta property="og:locale" content="tr_TR" />



      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify(structuredData || defaultStructuredData)}
      </script>
    </Helmet>
  );
};

export default SEO;